import React from 'react';
import { CheckCircle } from 'lucide-react';

const UnsubcribePage = () => {

    return (
        <div className="min-h-screen section-padding">
            <div className="container">
                <div className="max-w-2xl mx-auto text-center">
                    <div className="w-20 h-20 rounded-full bg-green-400/10 flex items-center justify-center mx-auto mb-8">
                        <CheckCircle className="h-10 w-10 text-green-400" />
                    </div>
                    <h1 className="display-md text-white mb-6">You’ve been unsubscribed!</h1>
                    <p className="body-lg mb-8">
                        You will no longer receive our emails. We're sorry to see you go!
                        If this was a mistake, you can resubscribe at any time.
                    </p>
                    <p className="body-md text-slate-400">
                        Thank you for being with us. We hope to connect with you again in the future.
                    </p>
                </div>
            </div>
        </div>
    );
};
export default UnsubcribePage;